import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { DevicesContext, IDevicesContext } from '../../devicesState/devicesContext';
import List from './components/List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Devices.module.scss';

const Devices: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, devices, currentPage, countOfItems } = useContext<IDevicesContext>(DevicesContext);

	return (
		<>
			{devices.count ? (
				<div className={style.container} data-test="Devices">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={devices.count}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default Devices;
